import * as React from "react";

import { Apps28Filled, Apps28Regular } from "@fluentui/react-icons";

import { TeamAppConfig } from "Apps/TeamAppModel";

const SCPHubApp = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "SCPHub" */ "./SCPHubApp");
    return { default: namedExport.SCPHubApp };
});

export const SCPHub: TeamAppConfig = {
    title: "SCP Hub",
    regularIcon: Apps28Regular,
    filledIcon: Apps28Filled,
    description: "Troubleshooting tools for SCP and CXP teams to investigate and resolve issues.",
    team: "SCP",
    publicId: "O365SERVICECOMMSPLATFORM\\SCP",
    owner: "ccpscp@microsoft.com",
    role: "*",
    flighting: ["scp", "substrate-scp", "scp-partner"],
    tags: ["SCP troubleshooting", "SCP Hub"],
    app: SCPHubApp,
    path: "/SCPHub"
};
